import { ActionItem, STORAGE_TRACE_KEY } from "../../types";
import Compose, { ACTION_LEVEL } from "../Compose";
import { getTraceInfo } from "../../page";
import { setTrace } from "../../store";

enum ACTION_ID {
    SUBMODULE = 125,
    ITEM = 102
}

export default class Expose extends Compose {
    compose(): ActionItem {
        const { level, page, item } = this.extraActionItem();

        // 只有子模块和物品支持点击行为
        if (
            [ACTION_LEVEL.SUBMODULE, ACTION_LEVEL.ITEM].includes(level) ===
            false
        ) {
            return null;
        }

        if (level === ACTION_LEVEL.SUBMODULE) {
            item.action_id = ACTION_ID.SUBMODULE;
        } else if (level === ACTION_LEVEL.ITEM) {
            // 业务会通过标注自定义action_id
            if (!item.action_id) {
                item.action_id = ACTION_ID.ITEM;
            }
        }

        setTrace(STORAGE_TRACE_KEY, getTraceInfo(page, item));

        return item;
    }
}
